import mutations, { SaleState } from "./mutations";
import actions from "./actions";
import getters from "./getters";

export default {
  namespaced: true,
  state: {} as SaleState,
  actions,
  getters,
  mutations,
};
